import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import Login from '../component/Login/Login';
import ForgotPassword from '../component/ForgotPassword/ForgotPassword';
import ConfirmPassword from '../component/ConfirmPassword/ConfirmPassword';
import Signup from '../component/Signup/Signup';
import MemberRegister from '../component/MemberRegister/MemberRegister';

import MainRouting from './MainRouting/MainRouting';

import PageCrud from '../Pages/PageCrud/PageCrud';
import RolePageCrud from '../Pages/RolePageCrud/RolePageCrud';
import HoaAdminNotification from '../Pages/HoaAdminNotification/HoaAdminNotification';
import HoaNavbar from '../component-vhoas/HoaNavbar/HoaNavbar';
import HoaComponent from '../component-vhoas/HoaComponent/HoaComponent';
import HoaHome from '../component-vhoas/HoaHome/HoaHome';
import HoaOffer from '../component-vhoas/HoaOffer/HoaOffer';
import HoaPlan from '../component-vhoas/HoaPlan/HoaPlan';
import HoaTestimonial from '../component-vhoas/HoaTestimonial/HoaTestimonial';
import HoaContact from '../component-vhoas/HoaContact/HoaContact';
import HoaFooter from '../component-vhoas/HoaFooter/HoaFooter';
import HoaCall from '../component-vhoas/HoaCall/HoaCall';
import HoaChoosePlan from '../component-vhoas/HoaChoosePlan/HoaChoosePlan';
import HoaPlanModal from '../component-vhoas/HoaPlanModal/HoaPlanModal';
import HoaModal from '../component-vhoas/HoaModal/HoaModal';
import HoaTermsConditions from '../component-vhoas/HoaTermsConditions/HoaTermsConditions';
import HoaVendorOnBoard from '../component-vhoas/HoaVendorOnBoard/HoaVendorOnBoard';
import HoaRegisterForm from '../component-vhoas/HoaRegisterForm/HoaRegisterForm';
import HOAMemberOnboard from "../component-vhoas/HOAMemberOnboard/MemberOnboard"
import HoaClientRegister from '../component-vhoas/HoaClientRegister/HoaClientRegister';

const Routing = () => {
  return (
    <Router>
      <Switch>
        {/* <Route exact path="/" component={Routering} /> */}
        <Route exact path="/hoa-noti" component={HoaAdminNotification} /> 
        <Route exact path="/nav" component={HoaNavbar} />
        <Route exact path="/"  component={HoaComponent} /> 
        <Route exact path="/hoa-home" component={HoaHome} />
        <Route exact path="/hoa-offer" component={HoaOffer} />
        <Route exact path="/hoa-plan" component={HoaPlan} />
        <Route exact path="/hoa-testimonial" component={HoaTestimonial} />
        <Route exact path="/hoa-contact" component={HoaContact} />
        <Route exact path="/hoa-footer" component={HoaFooter} />
        <Route exact path="/hoa-call" component={HoaCall} />
        <Route exact path="/hoa-choosePlan" component={HoaChoosePlan} />
        <Route exact path="/hoa-plan-modal" component={HoaPlanModal} />
        <Route exact path="/hoa-modal" component={HoaModal} />
        <Route exact path="/hoa-terms" component={HoaTermsConditions} /> 
        {/* <Route exact path="/hoa-insurance" component={HoaInsurance} /> */}
        <Route exact path="/hoa-vendor-onBoarding" component={HoaVendorOnBoard} />
        <Route exact path="/hoa-register/:roleId/:boardMemberRole" component={HoaRegisterForm} />
        <Route exact path="/hoa-member" component={HOAMemberOnboard} />
        <Route exact path="/hoa-client-register" component={HoaClientRegister} />

        <Route exact path="/login" component={Login} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/confirm-password/:userId" component={ConfirmPassword} />
        <Route exact path="/sign-in" component={Signup} />
        <Route exact path="/pages" component={PageCrud} />
        <Route exact path="/role-page" component={RolePageCrud} />
        <Route exact path="/member-register" component={MemberRegister} />
        <PrivateRoute path="/main" component={MainRouting} />
      </Switch>
    </Router>
  );
};

export default Routing;
